import { ChangeEvent } from '@faro/realtime-services';
import { ActivityCosts, StudyEntityType } from '@faro/study-designer-model';
import { useContext } from 'react';
import { ConsumerQueryOptions, useRealtimeQuery, UseRealtimeQueryResult } from '../../package/realtime-query';
import { ServiceContext } from '../ServiceContext';
import { activityCostsClient } from './ActivityCostsClient';

export interface ActivityCostsDataQuery {
    readonly studyId: string;
    readonly scheduleOfActivitiesId: string | undefined;
}

const metricsEntityTypes = [
    StudyEntityType.Activity,
    StudyEntityType.ActivityGroup,
    StudyEntityType.Epoch,
    StudyEntityType.ScheduledDay,
    StudyEntityType.StudyDesign,
    StudyEntityType.ScheduleOfActivities,
    StudyEntityType.Stage,
    StudyEntityType.Cycle,
    StudyEntityType.StudyAssessmentMeasurement,
    StudyEntityType.IntraDaySchedule,
];

export const useActivityCosts = (
    query: ActivityCostsDataQuery,
    options?: ConsumerQueryOptions<ActivityCosts[]>
): UseRealtimeQueryResult<ActivityCosts[], Error> => {
    const { studyId, scheduleOfActivitiesId } = query;
    const serviceContext = useContext(ServiceContext);

    const queryKey = ['activityCosts', studyId, scheduleOfActivitiesId];
    const events = serviceContext.changeEventService.events;
    const queryFn = async () => {
        return await activityCostsClient.get({ studyId, scheduleOfActivitiesId });
    };
    const refetchWhen = (event: ChangeEvent<any>) => {
        return event.scope === studyId && (metricsEntityTypes ?? []).includes(event.type);
    };

    return useRealtimeQuery({
        ...options,
        queryKey,
        events,
        queryFn,
        refetchWhen,
        gcTime: 0, // temporary fix for stale data. This effectly removes the query from the cache when the component unmounts
        enabled: scheduleOfActivitiesId !== undefined && (options?.enabled ?? true),
    });
};
